import InputSlider from '@/components/sections/builder/settings/input-slider';
import { ThemeLayoutType, useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export const DEFAULT_THEME_LAYOUT = {
  pageWidth: 1200,
  spaceSection: 0,
  spaceGridVertical: 4,
  spaceGridHorizontal: 4,
};

export default function ThemeLayoutSetting() {
  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const layout = builder.theme?.layout || DEFAULT_THEME_LAYOUT;

  const setLayout = (newLayout: Partial<ThemeLayoutType>) => {
    const updatedLayout = { ...layout, ...newLayout };
    builder.setTheme({ layout: updatedLayout });
  };

  return (
    <div>
      <InputSlider
        label='Page width'
        value={layout.pageWidth}
        max={1600}
        min={1000}
        onChange={(val) => setLayout({ pageWidth: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Space between template sections'
        value={layout.spaceSection}
        max={100}
        min={0}
        onChange={(val) => setLayout({ spaceSection: val })}
        rightContent={<div>px</div>}
      />
      <h3 className='mb-2 mt-4 font-bold'>Grid</h3>
      <p className='text-sm'>Affects areas with multiple columns or rows.</p>
      <InputSlider
        label='Horizontal space'
        value={layout.spaceGridVertical}
        max={40}
        min={4}
        onChange={(val) => setLayout({ spaceGridVertical: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Vertical space'
        value={layout.spaceGridHorizontal}
        max={40}
        min={4}
        onChange={(val) => {
          setLayout({ spaceGridHorizontal: val });
        }}
        rightContent={<div>px</div>}
      />
    </div>
  );
}
